import { DissectedError, DissectedErrorGroups, LogType, exists, logError } from '../../..'
import { ApiResponse } from '../../../types/Response'
import { DissectParserProps } from '../types/DissectParserTypes'

export const parseApiResponseJson = async <TApiResponse extends ApiResponse = ApiResponse>({
    responseBody,
    responseStatusText,
    responseStatus,
    caller,
}: DissectParserProps<TApiResponse>): Promise<void> => {
    let statusCode: number | null = null
    let statusMessage: string | null = null
    try {
        const apiResponse = (await responseBody) as TApiResponse

        statusCode = exists(apiResponse.errorCode) ? +apiResponse.errorCode : responseStatus
        statusMessage = apiResponse.message ?? responseStatusText
    } catch (error) {
        const message = 'unable to get apiResponse body'
        logError(message, { caller, logType: LogType.CATCH })
        throw new DissectedError((error as unknown as Error).message, {
            statusCode: statusCode ?? responseStatus,
            statusMessage: responseStatusText,
            callerAction: caller,
            errorGroup: DissectedErrorGroups.UNEXPECTED_ERROR_PARSING_RESPONSE_OBJECT,
            verboseMessage: 'unable to get apiResponse body',
        })
    }
}
